/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Confirm_Return_Defect_Qty_MaxInputs */

const vi_confirm_return_defect_qty_max = /** @type {(inputs: Confirm_Return_Defect_Qty_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SL lỗi không được vượt ${i?.max}`)
};

/**

* @param {Confirm_Return_Defect_Qty_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_defect_qty_max = /** @type {((inputs: Confirm_Return_Defect_Qty_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Defect_Qty_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_defect_qty_max(inputs)
});